import { appSchema } from '@shared/schema/appSchema.js';
import { flattenGraphSequence } from '@shared/graph/flattenGraphSequence.js';
import { formatAttributeKey } from '@shared/workflow/formatAttributeKey.js';
import { getLexicalArgKeys } from '@shared/workflow/getLexicalArgKeys.js';
import workflowScreenSelectors from '../redux/selectors/workflowScreenSelectors';
import { store } from '@/redux/lib/configureStore';

const getConditionDescriptionPart = ({ key, value, definition, placeholder }) => {
  if (value === undefined || value === null) {
    return { content: null, className: key, placeholder };
  }

  const state = store.getState();
  const workflow = workflowScreenSelectors.activeWorkflow(state);
  const steps = workflow?.steps;
  const graph = workflow?.graph;

  const sequence = graph && steps ? flattenGraphSequence(graph, steps, null, true) : [];

  if (key === 'operator') {
    const operator = appSchema?.api?.filters?.operators?.find((n) => n.value === value)?.shorthand || appSchema?.api?.filters?.operators?.[0]?.shorthand;
    return { content: operator, className: key, placeholder: 'Select an Operator' };
  }

  const parts = [];

  if (typeof value === 'string') {
    parts.push({ type: 'text', value: definition?.label || formatAttributeKey(value) });
  }

  const processLexicalParts = (lexicalValue) => {
    const lexicalParts = getLexicalArgKeys(lexicalValue);
    return lexicalParts.map((part) => {
      if (part?.type === 'block') {
        const step = steps?.find((s) => s.id === part?.stepId);
        const sequenceStep = sequence.find((s) => s.id === part?.stepId);
        return {
          ...part,
          stepNumber: sequenceStep?.stepNumber || step?.stepNumber
        };
      }
      return part;
    });
  };

  if (value?.type === 'lexical') {
    parts.push(...processLexicalParts(value?.value));
  }

  if (Array.isArray(value) && value.length === 1) {
    parts.push(...processLexicalParts(value?.[0]?.value));
  }

  if (Array.isArray(value) && value.length > 1) {
    parts.push({ type: 'text', value: `${value?.length} Values` });
  }

  const content = parts.length ? (
    <div className="lexical-input-wrapper workflow">
      {parts?.map((part, i) => {
        if (part?.type === 'block') {
          const stepNumber = part?.stepNumber || '';
          return (
            <div key={i} className={`lexical-block`}>
              <span className={'label'}>{`${stepNumber || ''} ${formatAttributeKey(part?.value)}`.trim()}</span>
            </div>
          );
        }
        return (
          <span key={i} className="text">
            {part?.value}
          </span>
        );
      })}
    </div>
  ) : null;

  return { content, className: key, placeholder };
};

export default getConditionDescriptionPart;
